var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.formVisible
    ? _c(
        "div",
        [
          _c(
            "el-dialog",
            {
              directives: [{ name: "dragDialog", rawName: "v-dragDialog" }],
              attrs: {
                title: _vm.formTitle,
                visible: _vm.formVisible,
                width: "600px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.formVisible = $event
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "dataForm",
                  attrs: {
                    model: _vm.addForm,
                    "label-width": "110px",
                    rules: _vm.formRules
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "奖品名称:", prop: "Name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          "auto-complete": "off",
                          placeholder: "请输入名称"
                        },
                        model: {
                          value: _vm.addForm.Name,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "Name", $$v)
                          },
                          expression: "addForm.Name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "奖品价值:", prop: "Price" } },
                    [
                      _c("el-input-number", {
                        attrs: { size: "small" },
                        model: {
                          value: _vm.addForm.Price,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "Price", $$v)
                          },
                          expression: "addForm.Price"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发行数量:", prop: "Count" } },
                    [
                      _c("el-input-number", {
                        attrs: { size: "small" },
                        model: {
                          value: _vm.addForm.Count,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "Count", $$v)
                          },
                          expression: "addForm.Count"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "有效起期:", prop: "BeginDate" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "date",
                          size: "small",
                          placeholder: "请选择开始日期"
                        },
                        model: {
                          value: _vm.addForm.BeginDate,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "BeginDate", $$v)
                          },
                          expression: "addForm.BeginDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "有效止期:", prop: "EndDate" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "date",
                          size: "small",
                          placeholder: "请选择截止日期"
                        },
                        model: {
                          value: _vm.addForm.EndDate,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "EndDate", $$v)
                          },
                          expression: "addForm.EndDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "奖品图片:", prop: "Logo" } },
                    [
                      _vm.addForm.Logo
                        ? _c("img", {
                            key: _vm.addForm.Logo,
                            staticStyle: { height: "60px" },
                            attrs: { src: _vm.baseUrl + _vm.addForm.Logo }
                          })
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          staticClass: "submit-btn",
                          attrs: { type: "warning", size: "mini" },
                          on: { click: _vm.selectFile }
                        },
                        [_vm._v("点此上传")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "兑奖说明:", prop: "Description" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 6,
                          "auto-complete": "off",
                          placeholder: "请输入兑奖说明"
                        },
                        model: {
                          value: _vm.addForm.Description,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "Description", $$v)
                          },
                          expression: "addForm.Description"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.formVisible = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit }
                    },
                    [_vm._v("提交")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("fileUploadNoUI", {
            ref: "fileUploadNoUI",
            on: { uploadSuccess: _vm.uploadSuccess }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }